import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-place",
  "use": "icon-place-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-place\"><defs><style type=\"text/css\"></style></defs><path d=\"M683.5 242.6L548.9 574.7l73 177.3h268z\" fill=\"#96a5b4\" opacity=\".4\" p-id=\"12240\" /><path d=\"M924.8 736.9L718.5 228c-5.7-14.2-19.5-23.4-34.5-23.4-16 0-29.3 9.3-35 23.4L548.6 475 412.7 145.7c-5.8-14-19.5-23.2-34.7-23.2-15.2 0-28.9 9.2-34.7 23.2L99.4 736.8c-4.8 11.6-3.5 24.9 3.5 35.3 7 10.4 18.7 16.9 31.2 16.9h755.8c12.5 0 24.2-6.5 31.2-16.8 7-10.4 8.4-23.8 3.7-35.3zM378 258.9L432.1 390H323.9L378 258.9zM190.2 714l118.4-287h138.8l118.4 287H190.2z m457 0l-57.7-139.9 94-231.9L834.2 714h-187zM883.5 827H134.9c-20.7 0-37.5 16.8-37.5 37.5s16.8 37.5 37.5 37.5h748.6c20.7 0 37.5-16.8 37.5-37.5S904.2 827 883.5 827z\" fill=\"#96a5b4\" p-id=\"12241\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/place.svg
// module id = 82yd
// module chunks = 178